import Breadcrumb from 'components/Common/Breadcrumb'
import { status } from 'constants/ShipperInformationStatus'
import { useFormik } from 'formik'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams } from 'react-router-dom'
import SelectSearch from 'react-select-search'
import { Button, Card, CardBody, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from 'reactstrap'
import { airShipperInfoStatusUpdate, getAirShipperInfo, seaShipperInfoStatusUpdate } from 'store/actions'
import * as Yup from "yup"
import Airfreight from 'pages/Printfiles/Airfreight'
import { useReactToPrint } from 'react-to-print'
import users_details from '../../assets/images/svg/enquiry/user-details.svg'
import PageLoader from 'components/Common/PageLoader'
import ConfirmationModal from 'components/Common/ConfirmationModal'

const AirShipperInformation = () => {
    document.title = "Shipper Information Details | Glottis Logistics"

    const { shipperId } = useParams()
    const user = JSON.parse(localStorage.getItem("authUser"));
    const dispatch = useDispatch()
    const history = useHistory()
    const [selectedGroup, setselectedGroup] = useState(null)
    const [statusModal, setStatusModal] = useState(false)
    const { shipperData, loader } = useSelector(state => ({
        shipperData: state.GetAirShipperInfo?.shipperInfo?.shipperInfo,
        loader:state.GetAirShipperInfo.loader,
    }))

    useEffect(() => {
        dispatch(getAirShipperInfo(shipperId, history))
    }, [shipperId])
    const shipperForm = useFormik({
        enableReinitialize: true,
        initialValues: {
            status: '',
            comment: ''
        },
        validationSchema: Yup.object({
            comment: Yup.string().required('Comment is required'),
            status: Yup.string().nullable().required('Status is required')
        }),
        onSubmit: (values) => {
            if (shipperForm.values?.status === 'completed') {
                setStatusModal(true)
            }
            else {
                setStatusModal(false)
                dispatchSI('no')
            }
        },
    })

    useEffect(() => {
        if (shipperData) setStatusValue(shipperData?.siStatusData?.shipperStatus)
    }, [shipperData])

    function setStatusValue(status) {
        if (status.toLowerCase() !== 'submitted' && status.toLowerCase() !== 'draft') {
            setselectedGroup(status);
            shipperForm.setFieldValue("status", status);
        } else {
            setselectedGroup('');
            shipperForm.setFieldValue("status", null)
        }
    } 
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });
    const dispatchSI = (status) => {
        const shipperInfo = {}
        const resetForm = shipperForm.resetForm();
        shipperInfo["status"] = shipperForm.values.status;
        shipperInfo["comments"] = shipperForm.values.comment;
        shipperInfo["shipperId"] = shipperId;
        shipperInfo["siStatusId"] = shipperData?.siStatusId;
        shipperInfo["completedStatus"] = status;
        dispatch(airShipperInfoStatusUpdate(shipperInfo, resetForm, dispatch, getAirShipperInfo, shipperId, history))
    }
    return (
        <>
            {loader === true ? <PageLoader /> : null}
            <div className="page-content shipper-details shipper-details-air">
                <div className="container-fluid accordion-style">
                    <Breadcrumb title="Enquiries" dashurl="/enquiries" breadcrumbItem={`Shipper information details - Air`} breadcrumbName="Shipper information details" />
                    <div className='text-end mb-4'>
                        <div style={{ display: "none" }}> <Airfreight reff={componentRef} shipperData={shipperData} /></div>
                        <button
                            type="button"
                            className="primary-button btn btn-secondary"
                            onClick={handlePrint}
                        >Print
                        </button>
                    </div>
                    <Card className='mt-3'>
                        <CardBody>
                            <div className='avater d-flex'>
                                <div className='icon avatar-sm rounded-circle align-self-center mini-stat-icon'>
                                    <img src={users_details} alt="" />
                                </div>
                                <p className='f-size-16 fw-600 mb-0'>User Details</p>
                            </div>
                            <Row>
                                <Col md="4">
                                    <FormGroup className="mb-3">
                                        <Label>Name</Label>
                                        <Label className='form-control d-flex align-items-center'>{shipperData?.userDetail?.firstName}{' '}{shipperData?.userDetail?.lastName} </Label>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup className="mb-3">
                                        <Label>Email</Label>
                                        <Label className='form-control d-flex align-items-center'><a href={`mailto:${"#"}`}>{shipperData?.userDetail?.email}</a></Label>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup className="mb-3">
                                        <Label>Phone number</Label>
                                        <Label className='form-control d-flex align-items-center'><a href={`tel:${"#"}`}>{shipperData?.userDetail?.phoneNumber}</a></Label>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup className="mb-3">
                                        <Label>Client code</Label>
                                        <Label className='form-control d-flex align-items-center'>{shipperData?.clientDetail?.clientCode}</Label>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup className="mb-3">
                                        <Label>Client Name</Label>
                                        <Label className='form-control d-flex align-items-center'>{shipperData?.clientDetail?.name}</Label>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md='6'>
                                            <Label>Exporter (Shipper)</Label>
                                            <Input type='textarea' className='textarea col-first' disabled value={shipperData?.exporter} />
                                        </Col>
                                        <Col md='6'>
                                            <Row className='mb-4'>
                                                <Col>
                                                    <Label>Telephone</Label>
                                                    <Label className='form-control d-flex align-items-center'>{shipperData?.exporterPhoneNumber}</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label>Mr./Mrs</Label>
                                                    <Label className='form-control d-flex align-items-center'>{shipperData?.MrOrMrs}</Label>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md='6'>
                                            <Label>Consignee (If "Order" enter notify party in space below)</Label>
                                            <Input type='textarea' className='textarea col-first' disabled value={shipperData?.consignee} />
                                        </Col>
                                        <Col md='6'>
                                            <Row className='mb-4'>
                                                <Col>
                                                    <Label>Telephone</Label>
                                                    <Label className='form-control d-flex align-items-center'>{shipperData?.consigneePhoneNumber}</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label>CTC person</Label>
                                                    <Label className='form-control d-flex align-items-center'>{shipperData?.consigneeCtcPerson}</Label>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md='6'>
                                            <Label>Notify Party (Only if not stated above:otherwise leave blank)</Label>
                                            <Input type='textarea' className='textarea col-first' disabled value={shipperData?.notifyParty} />
                                        </Col>
                                        <Col md='6'>
                                            <Row className='mb-4'>
                                                <Col>
                                                    <Label>Telephone</Label>
                                                    <Label className='form-control d-flex align-items-center'>{shipperData?.notifyPartyPhoneNumber}</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label>CTC person</Label>
                                                    <Label className='form-control d-flex align-items-center'>{shipperData?.notifyPartyCtcPerson}</Label>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md='6 form-group'>
                                            <Label>Airfreight Charges</Label>
                                            <div className='radio-group array-element mb-2'>
                                                <div className='radio-item'>
                                                    <Input
                                                        checked={shipperData?.airFreightChargesPrepaid === 'prepaid' ? true : false}
                                                        name="airFreightChargesPrepaid"
                                                        type="checkbox"
                                                        className="form-control"
                                                        id="prepaid-airFreightCharges"
                                                        onChange={() => { }}
                                                    />
                                                    <Label>To be prepaid</Label>
                                                </div>
                                                <div className='radio-item'>
                                                    <Input
                                                        checked={shipperData?.airFreightChargesCollected === 'collected' ? true : false}
                                                        name="airFreightChargesCollected"
                                                        type="checkbox"
                                                        className="form-control"
                                                        id="collected-airFreightCharges"
                                                        onChange={() => { }}
                                                    />
                                                    <Label>To be collected (If service availabele)</Label>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col md='6 form-group'>
                                            <Label>Other Charges</Label>
                                            <div className='radio-group array-element mb-2'>
                                                <div className='radio-item'>
                                                    <Input
                                                        checked={shipperData?.otherChargesPrepaid === 'prepaid' ? true : false}
                                                        name="otherChargesPrepaid"
                                                        type="checkbox"
                                                        className="form-control"
                                                        id="prepaid-otherCharges"
                                                        onChange={() => { }}
                                                    />
                                                    <Label>To be prepaid</Label>
                                                </div>
                                                <div className='radio-item'>
                                                    <Input
                                                        checked={shipperData?.otherChargesCollected === 'collected' ? true : false}
                                                        name="otherChargesCollected"
                                                        type="checkbox"
                                                        className="form-control"
                                                        id="collected-otherCharges"
                                                        onChange={() => { }}
                                                    />
                                                    <Label>To be collected (If service availabele)</Label>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md='6'>
                                            <Row className='mb-4'>
                                                <Col>
                                                    <Label>Export licence number</Label>
                                                    <Label className='form-control d-flex align-items-center'>{shipperData?.exportLicenceNumber}</Label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label>C.O.No</Label>
                                                    <Label className='form-control d-flex align-items-center col-first'>{shipperData?.cono}</Label>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col md='6'>
                                            <Label>Special instructions</Label>
                                            <Input type='textarea' className='textarea' disabled value={shipperData?.specialInstructions} />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md='4'>
                                            <Label>To (Airport of Destination)</Label>
                                            <Label className='form-control d-flex align-items-center'>{shipperData?.to}</Label>
                                        </Col>
                                        <Col md='4'>
                                            <Label>Country of origin</Label>
                                            <Label className='form-control d-flex align-items-center'>{shipperData?.countryOfOrigin}</Label>
                                        </Col>
                                        <Col md='4 form-group'>
                                            <Label>Airline Counter Signature</Label>
                                            <div className='radio-group array-element mb-2'>
                                                <div className='radio-item'>
                                                    <Input
                                                        checked={shipperData?.airLineCounterSignature === 'yes' ? true : false}
                                                        name="airLineCounterSignature"
                                                        type="radio"
                                                        className="form-control"
                                                        id="yes-airLineCounterSignature"
                                                        onChange={() => { }}
                                                    />
                                                    <Label>Yes</Label>
                                                </div>
                                                <div className='radio-item'>
                                                    <Input
                                                        checked={shipperData?.airLineCounterSignature === 'no' ? true : false}
                                                        name="airLineCounterSignature"
                                                        type="radio"
                                                        className="form-control"
                                                        id="no-airLineCounterSignature"
                                                        onChange={() => { }}
                                                    />
                                                    <Label>No</Label>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md='3'>
                                            <Label>Shipper C.O.D</Label>
                                            <Label className='form-control d-flex align-items-center'>{shipperData?.shippersCOD}</Label>
                                        </Col>
                                        <Col md='3'>
                                            <Label>Insurance amount</Label>
                                            <Label className='form-control d-flex align-items-center'>{shipperData?.insuranceAmount}</Label>
                                        </Col>
                                        <Col md='3'>
                                            <Label>Declared value for carriage</Label>
                                            <Label className='form-control d-flex align-items-center'>{shipperData?.declaredValueForCarriage}</Label>
                                        </Col>
                                        <Col md='3'>
                                            <Label>Declared value for customers</Label>
                                            <Label className='form-control d-flex align-items-center'>{shipperData?.declaredValueForCustomers}</Label>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody>
                            <h5 className='mb-4'>Package details</h5>
                            {shipperData?.containerDetails?.map((item, index) => (
                                <div className='card' key={index}>
                                    <div className='card-body'>
                                        <Row>
                                            <Col md='8'>
                                                <Row className='mb-4'>
                                                    <Col md='6'>
                                                        <div className='form-group'>
                                                            <Label>Mark and serial number</Label>
                                                            <Label className='form-control d-flex align-items-center'>{item?.markAndSerialNumber}</Label>
                                                        </div>
                                                    </Col>
                                                    <Col md='6'>
                                                        <div className='form-group'>
                                                            <Label>Number of packages</Label>
                                                            <Label className='form-control d-flex align-items-center'>{item?.kindOfPackages}</Label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col md='6'>
                                                        <div className='form-group'>
                                                            <Label>Gross weight (kg)</Label>
                                                            <Label className='form-control d-flex align-items-center'>{item?.grossWeight}</Label>
                                                        </div>
                                                    </Col>
                                                    <Col md='6'>
                                                        <div className='form-group'>
                                                            <Label>Measurement</Label>
                                                            <Label className='form-control d-flex align-items-center'>{item?.measurements}</Label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md='4'>
                                                <div className='form-group'>
                                                    <Label>Description of good's</Label>
                                                    <Input type='textarea' className='textarea' disabled value={item?.descriptionOfGoods} />
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            ))}
                        </CardBody>
                    </Card>

                    {(user?.user?.role === 'ADMIN' || user?.user?.role === 'SUPER_ADMIN') && (shipperData?.siStatusData?.shipperStatus !== 'completed') ?
                        <Card>
                            <CardBody>
                                <Form
                                    className="needs-validation"
                                    encType="multipart/form-data"
                                    onSubmit={e => {
                                        e.preventDefault()
                                        shipperForm.handleSubmit()
                                        return false
                                    }}>
                                    <Row>
                                        <Col md={6}>
                                            <p className='mb-2'>
                                                <Label>Current status :</Label> <span className='text-uppercase'>{shipperData?.siStatusData?.shipperStatus}</span>
                                            </p>
                                        </Col>
                                    </Row>
                                    {/* current admin comments need to be hide when empty */}
                                    {shipperData?.siStatusData?.comments &&
                                        <Row>
                                            <Col md={6} className='mb-3'>
                                                <p className='mb-0'>
                                                    <Label className='mb-0'>Current admin comments :</Label> {shipperData?.siStatusData?.comments}
                                                </p>
                                            </Col>
                                        </Row>
                                    }
                                    <Row>
                                        <Col md="4">
                                            <FormGroup className="mb-3">
                                                <Label>Status<span>*</span></Label>
                                                <div className={`position-relative`}>
                                                    <SelectSearch
                                                        options={(status)}
                                                        search={true}
                                                        name="status"
                                                        value={selectedGroup}
                                                        onChange={(e) => {
                                                            setStatusValue(e)
                                                        }}
                                                        onBlur={shipperForm.handleBlur}
                                                        invalid={
                                                            shipperForm.touched.status && shipperForm.errors.status ? true : false
                                                        }
                                                    />
                                                    <div className="select-down-arrow">
                                                        <i className="bx bx-chevron-down"></i>
                                                    </div>
                                                </div>
                                                {shipperForm.touched.status && shipperForm.errors.status ? (
                                                    <span className="role-error invalid-feedback">{shipperForm.errors.status}</span>
                                                ) : null}
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Label className='mt-3'>Comments <span>*</span></Label>
                                    <Row>
                                        <Col md={4}>
                                            <Input
                                                name="comment"
                                                type="textarea"
                                                className="form-control comment"
                                                onChange={shipperForm.handleChange}
                                                onBlur={shipperForm.handleBlur}
                                                value={shipperForm.values.comment || ""}
                                                invalid={shipperForm.touched.comment && shipperForm.errors.comment ? true : false}
                                            />
                                        </Col>
                                    </Row>
                                    {shipperForm.touched.comment &&
                                        shipperForm.errors.comment ? (
                                        <FormFeedback type="invalid">
                                            {shipperForm.errors.comment}
                                        </FormFeedback>
                                    ) : null}
                                    <div className='mt-3 d-flex action-btn'>
                                        <Button type='submit' className='mt-3 rounded-pill me-3 primary-button '>Submit</Button>
                                        <Button type='button' onClick={() => history.push('/enquiries')} className='mt-3 rounded-pill secountry-btn'>Back</Button>
                                    </div>
                                </Form>
                            </CardBody>
                        </Card> :
                        <div className='my-3 text-center'>
                            <Button type='button' onClick={() => history.push('/enquiries')} className='rounded-pill primary-button'>Back</Button>
                        </div>
                    }
                </div>
                {/* while changing si status to completed, the corresponding enquiry status status will change if we click confirm */}
                <ConfirmationModal
                    okButton={() => {
                        dispatchSI('yes')
                        setStatusModal(false)
                    }}
                    cancelButton={() => {
                        // dispatchSI('no')
                        setStatusModal(false);
                    }}
                    title={'Information'}
                    setStatusModal={setStatusModal}
                    statusModal={statusModal}
                    butttonName={"Yes"}
                    cancelBtnName={"No"}
                    content={<p>Since you are updating the status as completed for shipper information, it will complete the enquiry automatically.</p>}
                />
            </div>
        </>
    )
}

export default AirShipperInformation